/**
 * Utilidad para debug de WebSocket en consola del navegador
 *
 * Uso en la consola del navegador (F12):
 * - Habilitar: window.DEBUG_WS.enable()
 * - Deshabilitar: window.DEBUG_WS.disable()
 * - Ver estado: window.DEBUG_WS.status()
 * - Limpiar logs: window.DEBUG_WS.clear()
 */

const DebugWebSocket = {
  logs: [],
  enabled: localStorage.getItem('DEBUG_WS') === 'true',

  enable() {
    localStorage.setItem('DEBUG_WS', 'true');
    this.enabled = true;
    console.log('✅ Debug WebSocket HABILITADO. Recarga la página para ver los logs.');
  },

  disable() {
    localStorage.removeItem('DEBUG_WS');
    this.enabled = false;
    console.log('❌ Debug WebSocket DESHABILITADO.');
  },

  status() {
    console.group('📊 WebSocket Debug Status');
    console.log('Habilitado:', this.enabled);
    console.log('LocalStorage DEBUG_WS:', localStorage.getItem('DEBUG_WS'));
    console.log('Logs almacenados:', this.logs.length);
    console.groupEnd();
  },

  addLog(label, data) {
    const entry = {
      timestamp: new Date().toISOString(),
      label,
      data,
    };
    this.logs.push(entry);
    // Guardar últimos 50 logs
    if (this.logs.length > 50) {
      this.logs.shift();
    }
  },

  getLogs() {
    console.group('📋 WebSocket Logs');
    this.logs.forEach((log) => {
      console.log(`[${log.timestamp}] ${log.label}`, log.data);
    });
    console.groupEnd();
    return this.logs;
  },

  clear() {
    this.logs = [];
    console.log('🗑️ Logs limpiados');
  },

  exportLogs() {
    const data = JSON.stringify(this.logs, null, 2);
    console.log('📥 Logs para copiar:');
    console.log(data);
    return data;
  },
};

// Exponer en window para acceso desde consola
if (typeof window !== 'undefined') {
  window.DEBUG_WS = DebugWebSocket;
}

export default DebugWebSocket;
